export default {
  // Table Headers
  headers: {
    // Common headers
    result: "Result",
    results: "Results",
    current: "Current",
    examination: "Examination",
    test: "Test",
    flag: "Flag",
    flagText: "Flag",
    flags: "Flags",
    refRange: "Ref. Range",
    units: "Units",
    resultTime: "Date / Time",
    history: "History",
    actions: "Actions",
    visit_id: "Visit ID",
    barcode: "Barcode",
    sample_type: "Sample Type",
    total_results: "Results",
    sample_category: "Category",
    collection_time: "Collected",
    instrument: "Instrument",
    disk_rack: "Disk/Rack",
    position: "Position",
    sample_number: "Sample No.",
    sets_count: "Sets",
    pending_results: "Pending",
    approved_results: "Approved",
    sample_code: "Code",
    resultsCount: "No. of results",
  },

  no_data: "No data available",

  // Table toolbar
  toolbar: {
    refresh: "Refresh",
    pdf: "Download PDF",
    pdfAction: "Download",
    email: "Send by email",
    emailAction: "Email",
    moreActions: "More actions",
  },
};
